const utils = require('frontend-controller/lib/utils');
module.exports = {
    extends: [
        '/',
        'templates',
        'ninja',
        'table',
        'table',
    ],

    model: {
        eventParticipantDataStructures: null, // store structure of components loaded for additionalData and internalData
    },

    methods: {
        async getResourceRegister(){
            await this.prepareEventParticipantDataStructures()

            const {
                additionalDataStructure,
                internalDataStructure,
            } = (this.model.eventParticipantDataStructures || {})

            return {
                additionalDataStructure,
                internalDataStructure,
            }
        },

        async loadComponentModelFieldsByNinjaCodeName(ninjaCodeName){
            const context = await this.performAction(
                this.prepareAction(
                    'loadComponentModelFieldsByNinjaCodeName',
                    ninjaCodeName
                )
            )

            return (context.action || {}).response
        },

        prepareEventParticipantDataStructures(){
            // prepare data structures if necessary
            if(!this.model.eventParticipantDataStructures) {
                return utils.promise.resolveAll(this, [
                    this.loadComponentModelFieldsByNinjaCodeName('eventParticipantAdditionalData'),
                    this.loadComponentModelFieldsByNinjaCodeName('eventParticipantInternalData'),
                ]).then(response => {
                    this.model.eventParticipantDataStructures = {
                        additionalDataStructure: response.results[0],
                        internalDataStructure: response.results[1]
                    }

                    return utils.promise.resolve()
                })
            }

            return utils.promise.resolve()
        },
    },
}